/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppAutobuild } from "./AppAutobuild";
export const AppAutobuildResponse = core.serialization.object({
    data: AppAutobuild,
});
